import React from "react";
import "./Section4.css";
import w4 from "../images/curries.jpg";

function Section4({ image, height, children }) {
  return (
    <div
      className="parallax"
      style={{ "--parallax-height": height, "--parallax-image": `url(${w4})` }}
    >
      <div className="parallax-content">{children}</div>
    </div>
  );
}

export default Section4;
